import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Container,
  Grid,
} from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from "react-router-dom";
import logo from "../images/saleng shop.png";

const buttonsTop = [
  { label: "รับซื้อ", icon: <AddBoxOutlinedIcon />, route: "/buy" },
  { label: "รายงาน", icon: <DescriptionOutlinedIcon />, route: "/reports" },
  { label: "จัดการร้านค้า", icon: <SettingsIcon />, route: "https://shop.saleng.tjl.co.th", external: true  },

];

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <Box
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        background: "linear-gradient(135deg, #e0f7fa, #ffffff)",
        px: 2,
      }}
    >
      <Container maxWidth="md">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexWrap="wrap"
          sx={{ mb: 2 }}
        >
          <img
            src={logo}
            alt="logo"
            style={{ width: 200, height: "auto", marginRight: 16 }}
          />
          <Typography variant="h3" fontWeight="bold" sx={{ color: "#1976d2" }}>
            POS
          </Typography>
        </Box>

        {/* Welcome text */}
        <Typography variant="h6" align="center" sx={{ mb: 4 }}>
          ยินดีต้อนรับ! กรุณาเลือกเมนูด้านล่าง
        </Typography>

        {/* Button grid */}
        <Grid container spacing={4} justifyContent="center">
          {buttonsTop.map((btn, index) => (
            <Grid item xs={6} sm={4} md={3} key={index}>
              <Box
                     onClick={() => {
                      if (btn.external) {
                        window.open(btn.route, "_blank");
                      } else {
                        navigate(btn.route);
                      }
                    }}
                sx={{ cursor: "pointer", textAlign: "center" }}
              >
                <Paper
                  elevation={4}
                  sx={{
                    p: 3,
                    borderRadius: "50%",
                    backgroundColor: "#ffffff",
                    width: 120,
                    height: 120,
                    mx: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "all 0.3s",
                    ":hover": {
                      backgroundColor: "#1976d2",
                      color: "#fff",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  <IconButton color="inherit" size="large">
                    {btn.icon}
                  </IconButton>
                </Paper>
                <Typography
                  align="center"
                  sx={{ mt: 2, fontWeight: "bold" }}
                >
                  {btn.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default HomePage;
